<template>
  <div class="c-menuSidebar">
    <ul
      class="c-menuSidebar_userBusiness"
      v-if="headerType === HEADER_TYPE.BUSINESS"
    >
      <li class="js-headerGuideSpTarget1">
        <div class="dropdown-item c-avatar">
          <CUserIconV2
            :file-path="auth.user.resizableProfileIcon"
            :user-name="auth.user.name"
            :size="40"
            has-border
          />
          <div class="c-avatar_text">
            {{ auth.user.name }}
          </div>
        </div>
      </li>
    </ul>
    <template v-else>
      <ul class="c-menuSidebar_user">
        <li class="js-headerGuideSpTarget1">
          <DButton
            v-if="headerType === HEADER_TYPE.PROVIDER"
            type="outlined"
            size="small"
            is-bold
            icon-name="sync"
            class="c-menuSidebar_change"
            @click="$emit('change-header-to-buyer')"
          >
            購入モードへ切替
          </DButton>
          <DButton
            v-if="headerType === HEADER_TYPE.BUYER"
            type="outlined"
            size="small"
            is-bold
            icon-name="sync"
            class="c-menuSidebar_change"
            @click="$emit('change-header-to-provider')"
          >
            出品モードへ切替
          </DButton>
        </li>
        <li>
          <NuxtLink
            class="dropdown-item c-avatar"
            to="/mypage/user"
          >
            <CUserIconV2
              :file-path="auth.user.resizableProfileIcon"
              :user-name="auth.user.name"
              :size="40"
              has-border
              class="js-closeSidebar"
            />
            <div class="c-avatar_text js-closeSidebar">
              {{ auth.user.name }}
            </div>
          </NuxtLink>
        </li>
        <template v-if="headerType === HEADER_TYPE.PROVIDER">
          <li class="c-menuSidebar_buttons">
            <DButton
              href="/mypage/user"
              type="outlined2"
              size="small"
              is-bold
            >
              プロフィール編集
            </DButton>
            <DButton
              href="/mypage/user/info"
              type="outlined2"
              size="small"
              is-bold
            >
              スケジュール編集
            </DButton>
          </li>
          <li
            class="c-menuSidebar_phone"
            v-if="hasPhoneService"
          >
            <a
              class="dropdown-item"
              href="/mypage/pservices_lists?ref=spmenu"
            >
              <DLabel
                v-if="phoneEndTime > 0"
                text-color="White"
                background-color="Orange"
                class="c-menuSidebar_phoneLabel"
              >
                <CoconalaIcon name="phone" />
                {{ phoneEndTimeForLabel }}まで待機中
              </DLabel>
              <DLabel
                v-else
                text-color="White"
                background-color="Gray200"
                class="c-menuSidebar_phoneLabel"
              >
                <CoconalaIcon name="phone" />
                退席中
              </DLabel>
              設定を変更
            </a>
          </li>
        </template>
      </ul>
      <div
        class="c-menuSidebar_placeholder"
        :class="{
          'c-menuSidebar_placeholder-provider': headerType === HEADER_TYPE.PROVIDER && !hasPhoneService,
          'c-menuSidebar_placeholder-phone': headerType === HEADER_TYPE.PROVIDER && hasPhoneService
        }"
      ></div>
    </template>
    <ul class="c-menuSidebar_list">
      <template v-if="headerType === HEADER_TYPE.PROVIDER">
        <li>
          <NuxtLink
            class="dropdown-item"
            to="/mypage/dashboard_provider?ref=spmenu"
          >
            ダッシュボード
          </NuxtLink>
        </li>
        <li class="js-headerGuideSpTarget2">
          <a
            class="dropdown-item"
            href="/mypage/received_orders/open?ref=spmenu"
            @click="$emit('click-menu-guide-transaction')"
          >
            取引管理/見積り
          </a>
        </li>
        <li>
          <a
            class="dropdown-item"
            href="/mypage/services_lists?ref=spmenu"
          >
            出品サービス
          </a>
        </li>
        <li>
          <NuxtLink
            class="dropdown-item"
            to="/mypage/analytics?ref=spmenu"
          >
            分析
          </NuxtLink>
        </li>
        <li>
          <a
            class="dropdown-item"
            href="/mypage/offers?ref=spmenu"
          >
            提案
          </a>
        </li>
        <li>
          <NuxtLink
            class="dropdown-item"
            to="/mypage/blogs?ref=spmenu"
          >
            ブログ
          </NuxtLink>
        </li>
        <li>
          <a
            class="dropdown-item"
            href="/mypage/revenue?ref=spmenu"
          >
            売上
          </a>
        </li>
        <li>
          <NuxtLink
            class="dropdown-item"
            to="/mypage/received_favorites?ref=spmenu"
          >
            あなた宛のお気に入り
          </NuxtLink>
        </li>
        <li>
          <span class="dropdown-item">
            <DButton
              href="/services/add"
              size="small"
              is-bold
              class="c-menuSidebar_servicesAdd"
            >
              出品する
            </DButton>
          </span>
        </li>
      </template>
      <template v-else-if="headerType === HEADER_TYPE.BUYER || headerType === HEADER_TYPE.BUSINESS">
        <li>
          <NuxtLink
            class="dropdown-item"
            to="/"
          >
            ホーム
          </NuxtLink>
        </li>
        <li>
          <BCollapse :open="false">
            <div
              slot="trigger"
              slot-scope="props"
              class="dropdown-item c-menuSidebar_collapseTrigger"
              @click="$emit('change-service-search-collapse', !props.open)"
            >
              サービスを探す
              <CoconalaIcon
                :name="!props.open ? 'chevron-down' : 'chevron-up'"
                size="12px"
                color="ds2Gray600"
              />
            </div>
            <CategoryListForSidebar :is-business="headerType === HEADER_TYPE.BUSINESS" />
          </BCollapse>
        </li>
        <li v-if="headerType === HEADER_TYPE.BUYER && !Object.keys(businessAccountInfo).length">
          <NuxtLink
            class="dropdown-item dropdown-item c-menuSidebar_emphasis"
            to="/business/"
          >
            ビジネス購入の方はこちら
          </NuxtLink>
        </li>
        <li class="dropdown-divider"></li>
        <li>
          <NuxtLink
            class="dropdown-item"
            to="/mypage/dashboard?ref=spmenu"
          >
            ダッシュボード
          </NuxtLink>
        </li>
        <li class="js-headerGuideSpTarget2">
          <a
            class="dropdown-item"
            href="/mypage/orders/open?ref=spmenu"
            @click="$emit('click-menu-guide-transaction')"
          >
            取引管理/見積り
          </a>
        </li>
        <li>
          <a
            class="dropdown-item"
            href="/mypage/favorites?ref=spmenu"
          >
            お気に入り
          </a>
        </li>
        <li>
          <a
            class="dropdown-item"
            href="/mypage/requests?ref=spmenu"
          >
            公開依頼
          </a>
        </li>
        <li>
          <NuxtLink
            class="dropdown-item"
            to="/mypage/blog_orders?ref=spmenu"
          >
            購入ブログ
          </NuxtLink>
        </li>
        <li>
          <a
            class="dropdown-item"
            href="/points/top?ref=spmenu"
          >
            ポイント・クーポン・コイン
          </a>
        </li>
      </template>
      <li class="dropdown-divider"></li>
      <li v-if="headerType === HEADER_TYPE.BUSINESS">
        <NuxtLink
          class="dropdown-item"
          to="/switch_account"
        >
          個人・出品アカウントへ切替
        </NuxtLink>
      </li>
      <li v-else>
        <NuxtLink
          class="dropdown-item"
          to="/switch_account"
        >
          ビジネスアカウントへ切替
        </NuxtLink>
        <NuxtLink
          class="dropdown-item"
          :class="{ 'c-menuSidebar_invite': isViralCampaign }"
          to="/mypage/invite"
        >
          <span
            v-if="campaignText.sub"
            class="c-menuSidebar_subTitle"
            :class="{ 'c-menuSidebar_subTitle-campaign': isViralCampaign }"
          >{{ campaignText.sub }}</span>
          {{ campaignText.main }}
        </NuxtLink>
      </li>
      <template v-if="headerType === HEADER_TYPE.BUYER">
        <li>
          <NuxtLink
            class="dropdown-item"
            to="/mypage/orders/closed"
          >
            注文履歴
          </NuxtLink>
        </li>
        <li>
          <a
            class="dropdown-item"
            href="/mypage/user"
          >
            プロフィール編集
          </a>
        </li>
      </template>
      <li>
        <a
          class="dropdown-item"
          href="/mypage/user_account"
        >
          {{ headerType === HEADER_TYPE.BUSINESS ? '基本設定' : '設定' }}
        </a>
      </li>
      <li>
        <BCollapse :open="false">
          <div
            slot="trigger"
            slot-scope="props"
            class="dropdown-item c-menuSidebar_collapseTrigger"
          >
            ガイド・ヘルプ
            <CoconalaIcon
              :name="!props.open ? 'chevron-down' : 'chevron-up'"
              size="12px"
              color="ds2Gray600"
            />
          </div>
          <ul>
            <li v-if="headerType !== HEADER_TYPE.BUSINESS">
              <a
                class="dropdown-item c-menuSidebar_collapseItem"
                href="/pages/about"
              >
                はじめての方へ
              </a>
            </li>
            <li>
              <a
                class="dropdown-item c-menuSidebar_collapseItem"
                href="/pages/guide_top"
              >
                ご利用ガイド
              </a>
            </li>
            <li>
              <a
                class="dropdown-item c-menuSidebar_collapseItem"
                :href="$coconala.helpURL('/')"
              >
                お困りのときは
              </a>
            </li>
          </ul>
        </BCollapse>
      </li>
      <li v-if="headerType === HEADER_TYPE.BUYER">
        <span class="dropdown-item">
          <DButton
            href="/services/add"
            size="small"
            is-bold
            class="c-menuSidebar_servicesAdd"
          >
            出品する
          </DButton>
        </span>
      </li>
      <li>
        <a
          class="dropdown-item"
          href="/logout"
        >
          ログアウト
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import CategoryListForSidebar from '~/components/organisms/CategoryListForSidebar'
import { isViralCampaign, campaignText } from '../../../logics/viral-campaign'

import { mapState } from 'vuex'

export default {
  name: 'MenuSidebar',
  components: {
    CategoryListForSidebar,
    DButton: () => import('~/components/atoms/DS2/DButton' /* webpackChunkName: "DButton" */),
    DLabel: () => import('~/components/atoms/DS2/DLabel' /* webpackChunkName: "DLabel" */)
  },
  props: {
    headerType: {
      type: String,
      required: true
    },
    auth: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isViralCampaign: isViralCampaign(),
      campaignText: campaignText()
    }
  },
  computed: {
    ...mapState('constants', ['HEADER_TYPE']),
    ...mapState('my/header', ['hasPhoneService', 'phoneEndTime', 'businessAccountInfo']),
    phoneEndTimeForLabel() {
      const milliseconds = this.phoneEndTime * 1000
      const date = new Date(milliseconds)
      const hours = date.getHours()
      const minutes = date
        .getMinutes()
        .toString()
        .padStart(2, '0')
      return hours + ':' + minutes
    }
  }
}
</script>
<style lang="scss" scoped>
.c-menuSidebar {
  &_placeholder {
    height: 128px;

    &-provider {
      height: 170px;
    }

    &-phone {
      height: 208px;
    }
  }

  &_userBusiness {
    margin-top: 18px;
  }

  &_user {
    position: fixed;
    z-index: z(modal, title);
    width: 284px;
    background-color: $ds2-color-white;
  }

  &_change {
    margin: 24px 16px 14px;
    width: 252px;

    /deep/ .coconala-icon {
      font-size: 15px;

      &::before {
        vertical-align: -2px;
      }
    }
  }

  &_list {
    margin: 4px 0 50px;
  }

  .dropdown-item {
    padding: 10px 16px;
    color: $ds2-color-gray-900;
  }

  .dropdown-divider {
    margin: 12px 16px;
    background-color: $ds2-color-gray-50;
  }

  &_collapseTrigger {
    display: flex;

    align-items: center;
    justify-content: space-between;
  }

  &_collapseItem {
    margin-left: 20px;
  }

  &_buttons {
    display: flex;
    margin-bottom: 10px;
    padding: 0 16px;

    justify-content: space-between;

    .d-button {
      overflow: hidden;
      padding: 0 !important;
      width: 124px;
      white-space: nowrap;
    }
  }

  &_servicesAdd {
    width: 100%;
  }

  &_phone {
    margin-top: -4px;
  }

  &_phoneLabel {
    margin-right: 12px;
    vertical-align: 1px;
  }

  &_invite,
  &_emphasis {
    color: $ds2-color-brand-secondary !important;
  }

  &_subTitle {
    display: block;
    color: $ds2-color-orange-700;
    font-size: 11px;
    line-height: 1.2;
    &-campaign {
      color: $ds2-color-pink;
    }
  }
}

.c-avatar {
  display: flex;
  margin-bottom: 6px;
  padding: 6px 16px !important;
  height: auto !important;

  &_text {
    display: flex;
    margin: -1px 0 0 8px;
    width: 100%;
    white-space: normal;
    font-size: 14px;
    line-height: 1.5;

    align-items: center;
  }
}
</style>
